import { cloneDeep } from 'lodash'

import { FormGroupBase } from '../components/FormGroupBase'

/**
 * Form Builder with model sync capabilities.  You can think of this as a "factory"
 * for a FormGroup with some extra bells and whistles (model syncing)
 * @param {object} rawFormControls - FormControls
 * @returns {object} ExtendedFormGroup - Mixin
 */
const FormBuilderModelSync = (rawFormControls) => {
  const formGroup = FormGroupBase(rawFormControls, true)

  return {
    beforeMount() {
      if (this.modelValue) this.setInitialFormValues(this.modelValue)

      this.$_fbms_update_model()
      this.$_fbms_update_valid()
      this.$_fbms_update_errors()
    },
    computed: {
      ...formGroup.computed,
      $_fbms_value: {
        get() {
          return this.modelValue
        },
        set(value) {
          this.$emit('update:modelValue', value)
        },
      },
    },
    data() {
      // Deep clone the data to ensure each component instance has its own state
      return cloneDeep(formGroup.data)
    },
    emits: ['update:modelValue', 'update:valid', 'update:errors'],
    methods: {
      $_fbms_update_errors() {
        const { formErrors } = this
        this.$emit('update:errors', formErrors)
      },
      $_fbms_update_model() {
        const { formValues } = this

        this.$_fbms_value = formValues
      },
      $_fbms_update_valid() {
        const { isFormValid } = this

        this.$emit('update:valid', isFormValid)
      },
      ...formGroup.methods,
    },
    props: {
      /**
       * Errors from form
       */
      errors: { default: () => [], type: Array },

      /**
       * @model used by v-model
       */
      modelValue: { default: () => ({}), type: Object },

      /**
       * Form Valid State
       */
      valid: { default: false, type: Boolean },
    },
    watch: {
      ...formGroup.watch,
    },
  }
}

export { FormBuilderModelSync }
